<template>
	<v-dialog
    v-model="dialogSeguimiento.estatus"
    max-width="500px"
    transition="dialog-transition"
  >
    <v-card outlined class="pa-4">
      <v-card-title class="text-h6 font-weight-bold">
        Pasos para realizar un buen seguimiento
      </v-card-title>

      <v-divider class="my-3" />

      <!-- Filtro inicial en Twilio -->
      <section>
        <h3 class="text-subtitle-1 font-weight-bold mb-2">Filtro inicial en Twilio</h3>

        <p class="mb-3">
          Al ingresar a Twilio, siempre debemos colocar el primer filtro:
          <strong>INTERACCIÓN</strong>
        </p>

        <!-- Imagen opcional -->
        <v-img
          class="rounded-lg mb-2"
          max-width="520"
          src="@/assets/filtro_seguimiento.png"
          alt="Filtro Interacción en Twilio"
          contain
        />

        <p class="text-caption grey--text">
          (Opcional) Inserta aquí la captura del filtro de Twilio.
        </p>
      </section>

      <v-divider class="my-4" />

      <!-- Orden de prioridad -->
      <section>
        <h3 class="text-subtitle-1 font-weight-bold mb-2">
          Orden de prioridad para seguimiento de prospectos
        </h3>

        <p class="mb-4">
          El seguimiento <b>debe realizarse estrictamente en el siguiente orden</b>, de mayor a menor prioridad:
        </p>

        <v-list dense>
          <v-list-item v-for="(item, idx) in prioridades" :key="idx" class="align-start">
            <v-list-item-content>
              <div class="d-flex align-start">
                <div class="mr-3 font-weight-bold">
                  {{ idx + 1 }}.
                </div>

                <div>
                  <div class="font-weight-bold">
                    {{ item.titulo }}
                  </div>

                  <div class="mt-1">
                    <span class="font-weight-bold">Por qué:</span>
                    <span> {{ item.porque }}</span>
                  </div>
                </div>
              </div>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </section>

      <v-divider class="my-4" />

      <!-- Fuera de seguimiento activo -->
      <section>
        <h3 class="text-subtitle-1 font-weight-bold mb-2">
          Fuera de seguimiento activo
        </h3>

        <p class="mb-2">
          Estos estatus no requieren seguimiento:
        </p>

        <v-chip-group column>
          <v-chip
            v-for="(s, i) in noRequieren"
            :key="i"
            color="grey lighten-3"
            class="ma-1"
          >
            {{ s }}
          </v-chip>
        </v-chip-group>
      </section>
    </v-card>
  </v-dialog>
</template>
<script>
  import axios          from 'axios';
  import { mapGetters, mapActions } from 'vuex'


  export default {

  	props:[
  		'dialogSeguimiento'
  	],

    data: () => ({

    	// Cambia esta ruta por tu imagen real
      imgTwilio: "/img/twilio-filtro-interaccion.png",

      prioridades: [
        {
          titulo: "NUEVO",
          porque:
            "El prospecto escribe a varias escuelas. La primera que responde toma el control y gana la venta."
        },
        {
          titulo: "PENDIENTE DE PAGO",
          porque:
            "El cliente ya decidió. Si no cobramos rápido, otra opción puede robarnos el cierre."
        },
        {
          titulo: "EXAMEN REALIZADO",
          porque:
            "Ya invirtió tiempo y se visualiza dentro. Es uno de los momentos más fáciles para cerrar."
        },
        {
          titulo: "CON CITA AGENDADA",
          porque:
            "Quien agenda tiene intención. Confirmar asegura que avancemos al cierre."
        },
        {
          titulo: "LLAMADA AGENDADA",
          porque:
            "Cada llamada es una oportunidad real de venta. Perderla es perder dinero."
        },
        {
          titulo: "CLIENTE POTENCIAL",
          porque:
            "El interés sigue vivo. Si tardamos, el prospecto se enfría o se va con otra escuela."
        },
        {
          titulo: "EXAMEN ENVIADO",
          porque:
            "Si no lo empujamos, no lo hace. Quien da seguimiento, gana."
        },
        {
          titulo: "PRIMER CONTACTO",
          porque:
            "Aquí se decide si competimos o no por la venta. Avanzar o soltar rápido."
        },
        {
          titulo: "PAGO PARCIAL",
          porque:
            "Ya compró. Primero se prioriza a quienes aún no se deciden."
        }
      ],

      noRequieren: ["CLIENTE NO CONTESTA", "NO INTERESADO", "SPAM"]

    }),

    computed: {
    	...mapGetters('login',['getdatosUsuarioERPERP']),

    },

    methods:{

    }

  }
</script>
